/* eslint-disable no-invalid-this */
/* eslint-disable array-element-newline */
/* eslint-disable new-cap */
import {MobxReactionUpdate} from '@adobe/lit-mobx';
import {LitElement, html, nothing} from 'lit';
import styles from './product-page-select-button.component.scss?as=stylesheet';
import {ringBuilderStore} from '../../data/ring-builder-store';
import EventBus from '@mvps-genesis/event-bus';
import {PRODUCT_ATTRIBUTES_PARAM_KEY} from '../../data/constants';
import {classMap} from 'lit/directives/class-map.js';
import {defineCustomElement} from 'extensions/utils';

class ProductPageSelectButton extends MobxReactionUpdate(LitElement) {
	static get styles () {
		return [styles];
	}

	static get properties () {
		return {
			code: {
				type: String
			},
			store: {
				state: true,
				type: Object
			},
			type: {
				type: String
			}
		};
	}

	#form;

	constructor () {
		super();
	}

	handleFormChange = () => {
		this.requestUpdate();
	};

	handleVariantChange = ({detail: variant}) => {
		this.code = variant.code;
	};

	handleClick (e) {
		// "Disable" button if the outer form is not valid
		if (this.formValidity) {
			e.preventDefault();
			this.handeFormErrors();
			return false;
		}

		this.trackSelected();

		return true;
	}

	handeFormErrors () {
		const responseMessage = document.getElementById('js-purchase-message');
		if (!responseMessage) {
			return;
		}

		const missingAttrs = [];
		const attributes = this.#form.getElementsByClassName('required');
		for (const attribute of attributes) {
			missingAttrs.push(attribute.getAttribute('title'));
		}

		responseMessage.innerHTML = `All <em class="red">Required</em> options have not been selected.<br />Please review the following options: <span class="red">${missingAttrs.join(', ')}</span>.`;
		this.fadeIn(responseMessage);

		setTimeout(() => {
			this.fadeOut(responseMessage);
		}, 5000);
	}

	fadeIn (el, display) {
		el.style.opacity = 0;
		el.style.display = display || 'block';
		(function fade () {
			var val = parseFloat(el.style.opacity);
			if (!((val += 0.1) > 1)) {
				el.style.opacity = val;
				requestAnimationFrame(fade);
			}
		}());
	}

	fadeOut (el) {
		el.style.opacity = 1;
		(function fade () {
			if ((el.style.opacity -= 0.1) < 0) {
				el.style.display = 'none';
			} else {
				requestAnimationFrame(fade);
			}
		}());
	}

	connectedCallback () {
		super.connectedCallback();
		this.#form = this.closest('form');

		EventBus.addEventListener('PROD:getVariantData', this.handleVariantChange);

		this.#form.addEventListener('change', this.handleFormChange);
	}

	disconnectedCallback () {
		super.disconnectedCallback();

		EventBus.removeEventListener('PROD:getVariantData', this.handleVariantChange);

		this.#form.removeEventListener('change', this.handleFormChange);
	}

	async firstUpdated () {
		this.store = await ringBuilderStore;
	}

	get #formData () {
		return Array
			.from(new FormData(this.#form).entries())
			.filter(([key]) => key.startsWith(PRODUCT_ATTRIBUTES_PARAM_KEY));
	}

	get formValidity () {
		return !this.#form.checkValidity();
	}

	get selectProductHref () {
		let baseUrl = this.store?.ringBuilderUrl;
		let searchParams = this.store?.urlSearchParams;
		switch (this.type) {
			case 'diamond':
				if (this.store?.setting?.product?.id) {
					baseUrl = window.location.href;
					searchParams = [...searchParams, ...this.store?.reviewStepSearchParams];
				}
				break;
			case 'setting':
				if (this.store?.diamond?.product?.id) {
					baseUrl = window.location.href;
					searchParams = [...searchParams, ...this.store?.reviewStepSearchParams];
				}
				break;
			default:
				break;
		}

		const url = new URL(baseUrl, window.location.origin);

		// Add state url search params
		for (let [key, value] of searchParams) {
			url.searchParams.set(key, value);
		}

		// Add form data
		for (let [key, value] of this.#formData) {
			url.searchParams.set(key, value);
		}

		// Overwrite this product's state field
		url.searchParams.set(this.type, this.code);

		return url.toString();
	}

	render () {
		if (!this.store?.loaded) {
			return nothing;
		}

		const buttonClassMap = {
			button: true,
			'button-block': true,
			'button-square': true,
			'c-cta-style-3-button': true,
			nb: true,
			'select-setting-button': true,
			'u-color-secondary-white_1': true,
			uppercase: true
		};

		return html`
			<div>
				<a href="${this.selectProductHref}" @click="${this.handleClick}" class="${classMap(buttonClassMap)}">Choose this ${this.type}</a>
			</div>
		`;
	}

	trackSelected () {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'ga_event',
			/* eslint-disable camelcase */
			ga_event_action: 'Selection',
			ga_event_category: 'Ring Builder',
			ga_event_label: 'Setting',
			ga_event_non_interaction: false
			/* eslint-enable camelcase */
		});
	}
};

defineCustomElement('rb-product-page-select-button', ProductPageSelectButton);
